import { isEnvironmentProduction } from '@alexis/helpers/environment';
import { datadogRum } from '@datadog/browser-rum';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/index.module.scss';

console.log(
  '%c\n██╗    ██╗███████╗ ██████╗  ██████╗ \n██║    ██║██╔════╝██╔════╝ ██╔═══██╗\n██║ █╗ ██║█████╗  ██║  ███╗██║   ██║\n██║███╗██║██╔══╝  ██║   ██║██║   ██║\n╚███╔███╔╝███████╗╚██████╔╝╚██████╔╝\n ╚══╝╚══╝ ╚══════╝ ╚═════╝  ╚═════╝ \n\n',
  'color:#44b50c;',
);

const BOT_PATTERN =
  '(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';

const isBot = new RegExp(BOT_PATTERN, 'i').test(navigator.userAgent);

const sessionSampleRate = isBot ? 0 : 5;
const sessionReplaySampleRate = isBot ? 0 : 20;
const traceSampleRate = isBot ? 0 : 10;

datadogRum.init({
  applicationId: 'b59466d6-b51c-476a-b55c-fb53f278f137',
  clientToken: 'pub5e53adc01d8b59846cfe232653d2cee4',
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'datadoghq.com',
  service: 'desktop-web',
  env: isEnvironmentProduction(window.location.hostname) ? 'production' : 'staging',
  // Specify a version number to identify the deployed version of your application in Datadog
  version: DEPLOYMENT_VERSION,
  // `sessionSampleRate` is the percentage of sessions to track: 100 for all, 0 for none.
  //  Set to 5 to collect only 5% of all sessions.
  sessionSampleRate,
  sessionReplaySampleRate,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask',
  traceSampleRate,
  traceContextInjection: 'sampled',
  allowedTracingUrls: [
    isEnvironmentProduction(window.location.hostname)
      ? {
          match: 'https://srv.wego.com',
          propagatorTypes: ['tracecontext'],
        }
      : {
          match: 'https://srv.wegostaging.com',
          propagatorTypes: ['tracecontext'],
        },
  ],
  beforeSend(event) {
    if (event.type === 'error' && event.error.message.includes('Component unmount.')) {
      return false;
    }

    return true;
  },
});

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<App />);

serviceWorkerRegistration.register();
